
export default class MeetingError extends Error {
    constructor(message, type) {
        super(message);

        this.type = type;
    }
}